import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Authentication
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";

// Client Pages
import Dashboard from "./pages/Dashboard";
import InvoiceList from "./pages/InvoiceList";
import Reports from "./pages/Reports";
import Masters from "./pages/Masters";
import Settings from "./pages/Settings";

import Items from "./pages/Items";
import Customers from "./pages/Customers";
import Invoice from "./pages/Invoice";
import Purchase from "./pages/Purchase";
import PurchaseList from "./pages/PurchaseList"; // Import PurchaseList

import DailySales from "./pages/DailySales";
import StockReport from "./pages/StockReport";
import Stock from "./pages/Stock"; // Import Stock page
import Ledger from "./pages/Ledger";
import DayBook from "./pages/DayBook";
import RawBill from './pages/RawBill';
import RawBillList from './pages/RawBillList'; // Import RawBillList

// Payment Pages
import Payments from "./pages/Payments";
import PaymentList from "./pages/PaymentList";

// Data Management Page
import DataManagement from "./pages/DataManagement";

// Admin Pages
import AdminDashboard from "./pages/AdminDashboard";
import CreateUser from "./pages/CreateUser";
import UserList from "./pages/UserList";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Login - Public Route */}
        <Route path="/login" element={<Login />} />

        {/* Dashboard - Protected Route */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* CLIENT MODULES */}

        {/* Invoice Routes */}
        <Route
          path="/invoices"
          element={
            <ProtectedRoute>
              <InvoiceList />
            </ProtectedRoute>
          }
        />

        {/* Keep old route for backward compatibility */}
        <Route
          path="/invoicelist"
          element={
            <ProtectedRoute>
              <InvoiceList />
            </ProtectedRoute>
          }
        />

        {/* Reports */}
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />

        {/* Masters */}
        <Route
          path="/masters"
          element={
            <ProtectedRoute>
              <Masters />
            </ProtectedRoute>
          }
        />

        {/* Settings */}
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />

        {/* MASTER PAGES */}

        {/* Items Management */}
        <Route
          path="/items"
          element={
            <ProtectedRoute>
              <Items />
            </ProtectedRoute>
          }
        />

        {/* Customers Management */}
        <Route
          path="/customers"
          element={
            <ProtectedRoute>
              <Customers />
            </ProtectedRoute>
          }
        />

        {/* STOCK MANAGEMENT */}
        
        {/* Stock Management Page */}
        <Route
          path="/stock"
          element={
            <ProtectedRoute>
              <Stock />
            </ProtectedRoute>
          }
        />

        {/* DATA MANAGEMENT */}
        
        {/* Data Management Page - Backup, Restore, CA Export */}
        <Route
          path="/data-management"
          element={
            <ProtectedRoute>
              <DataManagement />
            </ProtectedRoute>
          }
        />

        {/* VOUCHERS */}

        {/* TAX INVOICE ROUTES */}
        
        {/* Create new tax invoice */}
        <Route
          path="/invoice/new"
          element={
            <ProtectedRoute>
              <Invoice />
            </ProtectedRoute>
          }
        />

        {/* Edit existing tax invoice */}
        <Route
          path="/invoice/edit/:id"
          element={
            <ProtectedRoute>
              <Invoice />
            </ProtectedRoute>
          }
        />

        {/* View tax invoice (read-only) */}
        <Route
          path="/invoice/view/:id"
          element={
            <ProtectedRoute>
              <Invoice />
            </ProtectedRoute>
          }
        />

        {/* Redirect old invoice path */}
        <Route
          path="/invoice"
          element={
            <ProtectedRoute>
              <Navigate to="/invoices" replace />
            </ProtectedRoute>
          }
        />

        {/* RAW BILL ROUTES - Separate from Tax Invoice */}
        
        {/* Raw Bill List Page - Main view */}
        <Route
          path="/raw-bills"
          element={
            <ProtectedRoute>
              <RawBillList />
            </ProtectedRoute>
          }
        />
        
        {/* Create new raw bill */}
        <Route
          path="/raw-bill/new"
          element={
            <ProtectedRoute>
              <RawBill />
            </ProtectedRoute>
          }
        />

        {/* Edit existing raw bill */}
        <Route
          path="/raw-bill/edit/:id"
          element={
            <ProtectedRoute>
              <RawBill />
            </ProtectedRoute>
          }
        />

        {/* View raw bill (read-only) */}
        <Route
          path="/raw-bill/view/:id"
          element={
            <ProtectedRoute>
              <RawBill />
            </ProtectedRoute>
          }
        />

        {/* Redirect old raw-bill path to list */}
        <Route
          path="/raw-bill"
          element={
            <ProtectedRoute>
              <Navigate to="/raw-bills" replace />
            </ProtectedRoute>
          }
        />

        {/* PURCHASE VOUCHER ROUTES */}
        
        {/* Purchase List Page - Main view */}
        <Route
          path="/PurchaseList"
          element={
            <ProtectedRoute>
              <PurchaseList />
            </ProtectedRoute>
          }
        />
        
        {/* Create new purchase */}
        <Route
          path="/purchase"
          element={
            <ProtectedRoute>
              <Purchase />
            </ProtectedRoute>
          }
        />

        {/* Edit existing purchase */}
        <Route
          path="/purchase/edit/:id"
          element={
            <ProtectedRoute>
              <Purchase />
            </ProtectedRoute>
          }
        />

        {/* View purchase (read-only) */}
        <Route
          path="/purchase/view/:id"
          element={
            <ProtectedRoute>
              <Purchase />
            </ProtectedRoute>
          }
        />

        {/* Redirect old purchase path to list */}
        <Route
          path="/purchases"
          element={
            <ProtectedRoute>
              <Navigate to="/PurchaseList" replace />
            </ProtectedRoute>
          }
        />

        {/* PAYMENT ROUTES */}
        
        {/* Payment List Page - Main view */}
        <Route
          path="/payments"
          element={
            <ProtectedRoute>
              <PaymentList />
            </ProtectedRoute>
          }
        />
        
        {/* Create new payment */}
        <Route
          path="/payment/new"
          element={
            <ProtectedRoute>
              <Payments />
            </ProtectedRoute>
          }
        />

        {/* Edit existing payment */}
        <Route
          path="/payment/edit/:id"
          element={
            <ProtectedRoute>
              <Payments />
            </ProtectedRoute>
          }
        />

        {/* View payment (read-only) */}
        <Route
          path="/payment/view/:id"
          element={
            <ProtectedRoute>
              <Payments />
            </ProtectedRoute>
          }
        />

        {/* Payment create page (alias) */}
        <Route
          path="/create-payment"
          element={
            <ProtectedRoute>
              <Payments />
            </ProtectedRoute>
          }
        />

        {/* REPORTS */}

        {/* Daily Sales Report */}
        <Route
          path="/daily-sales"
          element={
            <ProtectedRoute>
              <DailySales />
            </ProtectedRoute>
          }
        />

        {/* Stock Report */}
        <Route
          path="/stock-report"
          element={
            <ProtectedRoute>
              <StockReport />
            </ProtectedRoute>
          }
        />

        {/* Ledger Report */}
        <Route
          path="/ledger"
          element={
            <ProtectedRoute>
              <Ledger />
            </ProtectedRoute>
          }
        />

        {/* Day Book Report */}
        <Route
          path="/day-book"
          element={
            <ProtectedRoute>
              <DayBook />
            </ProtectedRoute>
          }
        />

        {/* ADMIN ROUTES */}

        {/* Admin Dashboard - Admin Only */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute role="admin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* Create User - Admin Only */}
        <Route
          path="/create-user"
          element={
            <ProtectedRoute role="admin">
              <CreateUser />
            </ProtectedRoute>
          }
        />

        {/* User List - Admin Only */}
        <Route
          path="/users"
          element={
            <ProtectedRoute role="admin">
              <UserList />
            </ProtectedRoute>
          }
        />

        {/* Redirect unknown routes to login */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;